import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ComponentCard from "../../../components/common/ComponentCard";
import Form from "../../../components/form/Form";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Select from "../../../components/form/Select";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateVenueArea() {
  const navigate = useNavigate();
  const location = useLocation();
  const area = location.state?.area; // Data from table row click

  const [formData, setFormData] = useState({
    name: "",
    status: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    status: "",
  });

  //Pre-fill the form with existing data
  useEffect(() => {
    if (area) {
      setFormData({
        name: area.name || "",
        status: area.status === 1 ? "current" : area.status === 2 ? "non-current" : "",
      });
    }
  }, [area]);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSelectChange = (option: any) => {
    setFormData({
      ...formData,
      status: option,
    });
    setErrors({
      ...errors,
      status: "",
    });
  };

  const validate = () => {
    let newErrors: any = {};
    if (!formData.name.trim()) newErrors.name = "Venue Area name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const token = localStorage.getItem("token");

      const payload = {
        name: formData.name,
        status: formData.status,
      };

      const response = await fetch(`${apiUrl}/venue_area/${area.venuearea_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        navigate("/venue-areas");
      } else {
        console.error("Failed to update venue area:", await response.text());
      }
    } catch (err) {
      console.error("Error updating venue area:", err);
    }
  };

  const handleCancel = () => {
    navigate("/venue-areas");
  };

  return (
    <ComponentCard title="Update Venue Area">
      <Form onSubmit={handleSubmit}>
        <div className="grid gap-6">
          <div className="col-span-full">
            <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
              Venue Area
            </h4>
          </div>

          {/* Venue Area Name */}
          <div>
            <Label>Venue Area Name</Label>
            <Input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
          </div>

          {/* Record Status */}
          <div>
            <Label>Record Status</Label>
            <Select
              options={[
                { value: "current", label: "Current" },
                { value: "non-current", label: "Non-Current" },
              ]}
              onChange={handleSelectChange}
              value={formData.status}
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />
          </div>

          <div className="flex gap-3">
            <Button size="sm" type="submit" >Update Changes</Button>
            <Button size="sm" variant="outline" type="button" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </Form>
    </ComponentCard>
  );
}
